import { render, staticRenderFns } from "./PublicBooking.vue?vue&type=template&id=6905487a&scoped=true"
import script from "./PublicBooking.vue?vue&type=script&lang=js"
export * from "./PublicBooking.vue?vue&type=script&lang=js"
import style0 from "./PublicBooking.vue?vue&type=style&index=0&id=6905487a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6905487a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VAvatar,VBtn,VContainer,VIcon,VSheet})
